import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
    selector: 'tt-invoice-head-ehf',
    templateUrl: './invoice-head-ehf.component.html',
    styleUrls: ['./invoice-head-ehf.component.css'],
    standalone: false
})
export class InvoiceHeadEhfComponent implements OnInit {
    invoiceNo;

    public linkId = 'formInvoiceHeadEhfLink';

    public edit?: Edit;

    public creatingEhf = false;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.invoiceNo = this.stateService.getStateParams()['invoice_no'];
    }

    private async loadEdit() {
        if (!!this.invoiceNo) {
            this.edit = (await this.datatask.Post(909, { invoice_no: this.invoiceNo }))[0];
        }
    }

    public async createEhfFile() {
        if (!!this.edit) {
            try {
                this.creatingEhf = true;

                const response = (await this.datatask.Post(910, this.edit))[0];

                this.edit.ehf_content = response?.ehf_content;
            } finally {
                this.creatingEhf = false;
            }
        }
    }

    public saveToFile(): void {
        if (!!this.edit) {
            try {
                this.saving = true;

                const elem = document.getElementById(this.linkId);
                const text = this.edit!.ehf_content;

                if (!elem || !text) {
                    return;
                }

                const xmlData = new Blob([text], { type: 'text/xml' });
                const xmlUrl = URL.createObjectURL(xmlData);

                elem.setAttribute('href', xmlUrl);
                elem.setAttribute('download', this.edit!.filename ?? '');
                elem.click();

                URL.revokeObjectURL(xmlUrl);
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    invoice_no: string | number;
    ehf_content: string | undefined;
    filename: string;
}
